<template>
  <Modal
    :open="welcomeWesave && !isAdvisor"
    :sidebar="true"
    :hide-close="false"
    hide-scroll
    @close="onClose"
  >
    <template slot="sidebar">
      <img
        class="pub-modal-img"
        :src="bestImageRatio('/static/club-modal')"
      >
    </template>

    <template slot="body">

    <div class="pub-welcome-modal">
      <div class="title">
        {{ $t('devices.welcome-modal.title') }}
      </div>

      <div class="content">
        {{ $t('devices.welcome-modal.content') }}
      </div>

      <div class="list-title">
        {{ $t('devices.welcome-modal.list.title') }}
      </div>

      <ul>
        <li>{{ $t('devices.welcome-modal.list.contracts') }}</li>
        <li>{{ $t('devices.welcome-modal.list.real-estates') }}</li>
        <li>{{ $t('devices.welcome-modal.list.savings') }}</li>
        <li v-if="!isESROnboardingOrigin">{{ $t('devices.welcome-modal.list.consultations') }}</li>
      </ul>

      <div class="modal-button">
        <x-button
          v-if="!isESROnboardingOrigin"
          class="md-raised md-primary"
          @click="resendValidation"
        >
          {{ $t('devices.welcome-modal.button') }}
        </x-button>
        <x-button
          v-else
          class="md-raised md-primary"
          @click="upgradeAccountFeaturesClick"
        >
          {{ $t('devices.welcome-modal.button-access') }}
        </x-button>
      </div>
      <span
        class="link"
        @click="goToLandingPage"
      >
        {{ $t('devices.welcome-modal.link') }}
      </span>
    </div>
    </template>
  </Modal>
</template>

<script>

import { bestImageRatio } from '@/utils/responsive'
import Modal from '@/components/modal'
import IcCheckCircle from '@/svg/ic-check-circle'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'FeaturesPubModal',

  components: {
    Modal,
    IcCheckCircle
  },
  computed: {
    ...mapGetters({
      isAdvisor: 'auth/isAdvisor',
      isESROnboardingOrigin: 'user/isESROnboardingOrigin'
    }),
    ...mapState({
      welcomeWesave: state => state.welcomeWesave
    })
  },
  methods: {
    bestImageRatio,
    onClose () {
      return this.$emit('close')
    },
    goToLandingPage () {
      this.$emit('close')
      window.open(process.env.SITE_URL_LANDING_PAGE, '_blank')
    },
    resendValidation() {
      this.resendValidationMail()
        .then(() => {
          this.$store.dispatch('toasts/addMessage', {
            component: 'app-toast',
            body: this.$t('toast.merge_validation_email_sent')
          })
        })
      this.$emit('close')
    },
    ...mapActions({
      resendValidationMail: 'auth/resendValidationMail'
    }),
    upgradeAccountFeaturesClick() {
      this.onClose()
      this.$router.push({ name: 'upgrade-account-features' })
    }
  }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
@import '~@/styles/vars.scss';
.pub-modal-img {
  min-width: 30rem;
  height: 46rem;
}
.pub-welcome-modal {
  .title {
    margin-top: $space-medium;
    color: $color-unknown;
    font-size: 2.4rem;
    font-weight: 600;
    line-height: 3.1rem;
  }

  .content {
    margin-top: $space-small;
    color: $color-daddy;
    font-weight: 600;
    line-height: 2rem;
  }

  .link {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    color: map_get($palette-primary, main);
    font-weight: 600;
    line-height: 2rem;
    text-decoration: underline;
    cursor: pointer;
  }

  .list-title {
    color: $color-daddy;
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 1.8rem;
    text-transform: uppercase;
  }

  > ul {
    list-style: none;
    padding: 0;
    li {
      background-image: url('../../assets/ic-check-circle.svg');
      background-position: left center;
      background-size: 1.6rem;
      background-repeat: no-repeat;
      padding-left: 1.6em;
      margin-top: $space-medium;
      color: $color-galaxy;
      font-size: 1.5rem;
      line-height: 1.8rem;
      text-align: justify;
      display: flex;
      align-items: center;
    }
  }

  .modal-button {
    margin-top: 2rem;
    text-align: center;
  }
}
</style>